import { render, staticRenderFns } from "./CreateSetPage.vue?vue&type=template&id=830277b0"
import script from "./CreateSetPage.vue?vue&type=script&lang=js"
export * from "./CreateSetPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports